import React from 'react';

// One card's failure is that card's, not the page's (librarian B29 P2.6).
//
// The LLM columns are written by a pipeline this app doesn't control, and a shape it
// didn't expect (a play whose `text` isn't a string, a narrative that's an object)
// used to blank the whole page: nothing above the cards caught a throw. Wrapped in
// this, the card renders nothing instead, and the rest of the page stands.
//
// - **No wrapper element:** it renders its children as they are, so it changes no DOM
//   (the v1 pins compare innerHTML).
// - **`resetKey`:** clears a caught error when it changes, so a card that failed on a
//   stale cached copy comes back once the fresh one arrives, and a reused instance gets
//   a fresh chance when the page moves to another game. A `key` would do that too, but
//   would remount the card and lose its state.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, resetKey: props.resetKey };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.resetKey !== state.resetKey) return { error: null, resetKey: props.resetKey };
    return null;
  }

  componentDidCatch(error) {
    // A warning, not an error: the page is fine, one card isn't.
    console.warn(`A card failed and was left out (${this.props.name || 'card'}):`, error?.message || error);
  }

  render() {
    return this.state.error ? null : this.props.children;
  }
}
